import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root',
})
export class UserService extends ApiService {
  currentEmployeeSubject$ = new BehaviorSubject<any>(null);

  public get currentEmployee(): any {
    return this.currentEmployeeSubject$.getValue();
  }
  currentUserContact$: BehaviorSubject<any> = new BehaviorSubject(null);
  get userContact() {
    var _contact = this.currentUserContact$.getValue();
    return _contact;
  }

  currentPerson$: BehaviorSubject<any> = new BehaviorSubject(null);
  get currentPerson() {
    var _currentPerson = this.currentPerson$.getValue();
    return _currentPerson;
  }
  regiser(data: any) {
    return;
  }

  changePassword(data: any) {
    return this.http.post(
      this.identityBaseUrl + '/api/users/change-password',
      data
    );
  }

  getUserContact() {
    return this.http.get(this.identityBaseUrl + '/api/users/contact');
  }
  getTenantRootPermissions() {
    return this.http.get(
      this.identityBaseUrl + '/api/tenant/tenantUsers/root-permissions'
    );
  }
  async getTenantRootPermissionsAsync(): Promise<any> {
    try {
      const response = await firstValueFrom(
        this.http.get<boolean>(
          this.identityBaseUrl + '/api/tenant/tenantUsers/root-permissions'
        )
      );
      return response;
    } catch (error) {
      console.error('Permission check failed', error);
      return null;
    }
  }
  changeImage(file: string) {
    return this.http.post(this.identityBaseUrl + '/api/users/changeImage', {
      base64String: file,
    });
  }

  setActiveClinic(clinicId: string) {
    return this.http.post(this.identityBaseUrl + '/api/users/active-clinic', {
      clinicId,
    });
  }
  setActivePosition(clinicId: string, positionId: string, warehouseId: string) {
    return this.http.post(this.identityBaseUrl + '/api/users/active-position', {
      clinicId,
      positionId,
      warehouseId,
    });
  }
  getUsersByPersonId(personId: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.identityBaseUrl}/api/users/getUsersByPersonId/${personId}`
    );
  }

  getCurrentEmployee(): Observable<any> {
    return this.http.get<any>(
      `${this.clinicsBaseURL}/api/employees/getCurrentEmployee`
    );
  }
  getPersonUsers(): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.identityBaseUrl}/api/users/getPersonUsers`
    );
  }
  getUserPerson() {
    return this.http.get(`${this.persionBaseURL}/api/persons/user/person`);
  }
}
